import {
  sendRdEventCpfBirthDateDto,
  sendRdEventPersonalDataDto,
} from '@interfaces/rdStation';
import { fetcher } from '@utils/fetcher';

const API_URL = '/api/rdStation';

// Finalizou 1a etapa do cadastro (nome, email, telefone)
export const sendRdEventPersonalData = async (
  dto: sendRdEventPersonalDataDto,
) => fetcher(`${API_URL}/personalData`, { method: 'POST', body: dto });

// Finalizou 2a etapa do cadastro (CPF, data de nascimento)
export const sendRdEventCpfBirthDate = async (
  dto: sendRdEventCpfBirthDateDto,
) => fetcher(`${API_URL}/cpfBirthDate`, { method: 'POST', body: dto });

// Finalizou etapa "Informações" da criação de grupo
export const sendRdEventInfoStepDone = async () =>
  fetcher(`${API_URL}/infoStepDone`, { method: 'POST' });

// Copiou o link de divulgação do bot
export const sendRdEventBotLinkCopied = async () =>
  fetcher(`${API_URL}/botLinkCopied`, { method: 'POST' });
